// extracted by mini-css-extract-plugin
export default {"contentContainer":"DataTables_contentContainer__a0Pjc"};